import apiClient from "../api/client";

export interface SavePageHighlightsRequest {
  pageGuid: string;
  createdBy: string;
  highlightSelections: string[];
}

export async function getPageHighlightsById(
  pageGuid: string
): Promise<string[]> {
  const response = await apiClient.get<{ name: string }[]>(
    "/api/Page/GetPageHighlightsById",
    {
      params: { id: pageGuid },
    }
  );

  return response.data.map((h) => h.name);
}

export async function savePageHighlights(
  payload: SavePageHighlightsRequest
): Promise<void> {
  await apiClient.post(
    "/api/Page/SavePageHighlights",
    payload
  );
}